import React from 'react';
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link, Tooltip} from '@mui/material';
import IconButton from "@mui/material/IconButton";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ContractActionMenu from "./ContractActionMenu";
import ContractStatusMenu from "./ContractStatusMenu";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";



export const WorkQueueContractGridColumns = ({ hideActions, removeContract, fetchContracts, handleDeleteCancel,
                                                 handleDrilldown, handleMousedRow, handleClickedRow,handleDeleteClose, deleteOpen,
                                                    selectorContractId,
                                                 expandProductId}) =>
 [

    {
        field: "contractExplore",
        headerName: '',
        width: 30,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filter: false,
        hide: true,
        renderCell: (contracts) => {
            return (
                // renderCell: (cellValues) => {
                //     return (
                //         render: (text, contract) =>
                <Link to={"/ContractDrilldown"}>
                    <IconButton
                        size="small"
                        variant="contained"
                        color="primary"
                    >
                        <MenuBookIcon
                            onClick= {() => handleDrilldown(contracts.row.contractId, contracts.row.mcode, contracts.row.name, contracts.row.description, contracts.row)}/>
                    </IconButton>
                </Link>

            );
        }
    },

    {    field: 'id',
        headerName: 'ID',
        description: '',
        sortable: true,
        width: 60,
        hide: true
    },
    {    field: 'contractId',
        headerName: 'ID',
        description: '',
        sortable: true,
        width: 60,
        hide: true
    },
    {
        field: 'mcode',

        headerName: 'Code',
        description: '',
        sortable: true,
        editable: true,
        // editable: true,
        width: 200,
        hide: true
    },
    {
        field: 'hierarchy',

        headerName: 'hierarchy',
        description: '',
        sortable: true,
        editable: true,
        // editable: true,
        width: 200,
        hide: true
    },
    {
        field: 'hierarchyNew',

        headerName: 'hierarchy new',
        description: '',
        sortable: true,
        editable: true,
        // editable: true,
        width: 200,
        hide: true
    },
    {
        field: 'inputMissingCount',
        headerName: 'inputMissingCount',
        description: '',
        sortable: true,
        editable: true,
        // editable: true,
        width: 50,
        hide: true
    },
    {
        field: 'excpetionType',
        headerName: 'excpetionType',
        description: '',
        sortable: true,
        editable: true,
        // editable: true,
        width: 50,
        hide: true
    },
    {
        field: 'groupedStatus',
        headerName: 'groupedStatus',
        description: '',
        sortable: true,
        editable: true,
        // editable: true,
        width: 50,
        hide: true
    },
    {
        field: 'comboStatus',
        headerName: 'cs',
        description: '',
        sortable: true,
        editable: true,
        // editable: true,
        width: 50,
        hide: true
    },
    {
        field: 'inputMissingRollup',
        headerName: 'inputMissingRollup',
        description: '',
        sortable: true,
        editable: true,
        // editable: true,
        width: 50,
        hide: true
    },
    {
        field: 'actions',
        headerName: '',
        disableColumnMenu: true,
        width: 20,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filterable: false,
        renderCell: (contracts) => {
            const rowContractData = contracts.row;
            return (<div onMouseOver={() => handleMousedRow(contracts.row)}>
                    {/*// <MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>*/}
                    <ContractActionMenu rowContractData={rowContractData}
                                       />
                </div>
            );
        }
    },
    {
        field: 'contractStatus',
        headerName: '',
        disableColumnMenu: true,
        width: 20,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filterable: false,
        renderCell: (contracts) => {
            const rowContractData = contracts.row;
            return (<div onMouseOver={() => handleMousedRow(contracts.row)}>
                    {/*// <MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>*/}
                    <ContractStatusMenu rowContractData={rowContractData}/>
                </div>
            );
        }
    },
    {
        // field: 'name',
        field: 'displayName',
        headerClassName: 'colored-header',
        //
        // renderHeader: () => (
        //         <Box sx={{ display: 'flex', alignItems: 'right', gap: 0.1, pl: 0.5 }}>
        //             <Stack direction="row" spacing={1}>
        //             <Tooltip title="Collapse All">
        //                 <IconButton
        //                     sx={{ p: 0.25 }}          // ✅ smaller hit area = tighter look
        //                     size="small"
        //                     // onClick={(e) => {
        //                     //     e.stopPropagation();
        //                     //     stepDepth(-1);        // or collapseAll()
        //                     // }}
        //                     onClick={() => {
        //                         dispatchData(changeWork({expansionDepth: 0}));}}
        //                     aria-label="collapse all expansion depth"
        //                 >
        //                     {/*<UnfoldLessDouble fontSize="small" />*/}
        //                     <Icon className="material-symbols-outlined">unfold_less_double</Icon>
        //                 </IconButton>
        //             </Tooltip>
        //             <Tooltip title="Decrease depth (Collapse)">
        //                 <IconButton
        //                     sx={{ p: 0.25 }}          // ✅ smaller hit area = tighter look
        //                     size="small"
        //                     // onClick={(e) => {
        //                     //     e.stopPropagation();
        //                     //     stepDepth(-1);        // or collapseAll()
        //                     // }}
        //                     onClick={() => {
        //                         dispatchData(changeWork({expansionDepth: selectorExpansionDepth - 1}));}}
        //                     aria-label="decrease expansion depth"
        //                 >
        //                     <UnfoldLess fontSize="small" />
        //                 </IconButton>
        //             </Tooltip>
        //
        //             <Tooltip title="Increase depth (Expand)">
        //                 <IconButton
        //                     sx={{ p: 0.25 }}          // ✅ smaller hit area = tighter look
        //                     size="small"
        //                     // onClick={(e) => {
        //                     //     e.stopPropagation();
        //                     //     stepDepth(+1);        // or expandAll()
        //                     // }}
        //                     onClick={() => {
        //                         dispatchData(changeWork({expansionDepth: selectorExpansionDepth + 1}));}}
        //                     aria-label="increase expansion depth"
        //                 >
        //                     <UnfoldMore fontSize="small" />
        //                 </IconButton>
        //             </Tooltip>
        //
        //             <Tooltip title="Expand all">
        //                 <IconButton
        //                     sx={{ p: 0.25 }}          // ✅ smaller hit area = tighter look
        //                     size="small"
        //                     // onClick={(e) => {
        //                     //     e.stopPropagation();
        //                     //     stepDepth(+1);        // or expandAll()
        //                     // }}
        //                     onClick={() => {
        //                         dispatchData(changeWork({expansionDepth: -1}));}}
        //                     aria-label="expand all"
        //                 >
        //                     {/*<UnfoldMoreDouble fontSize="small" />*/}
        //                     <Icon className="material-symbols-outlined">unfold_more_double</Icon>
        //                 </IconButton>
        //             </Tooltip>
        //             </Stack>
        //         </Box>
        // ),
        headerName: 'Name',
        description: '',
        sortable: false,
        editable: true,
        width: 430,
        renderCell: (contracts) => {
            return (
            <div>
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={<span style={{whiteSpace: 'pre-line'}}>
                    { "property id: " + contracts.row.propertyId +
                        "\nid: " + contracts.row.contractId +
                        "\nstatus: " + contracts.row.status +
                        "\nmissing inputs: " + contracts.row.inputMissingCount +
                        "\nfailed filters: " + contracts.row.failedFilterCount +
                        "\nfailed expressions: " + contracts.row.failedExpressionCount
                    }</span>}>

                        <p
                            onClick= {() => handleClickedRow(contracts.row)}
                            style={{
                                cursor: contracts.row.contractId !== 0 ? 'pointer' : 'not-allowed',
                                // backgroundColor: contracts.row.propertyId === (expandProductId ? expandProductId.toString() : '0') ? 'yellow' : 'transparent',
                                textDecoration: contracts.row.contractId === selectorContractId && selectorContractId > 0 ? 'underline' : 'none',
                            }}>

                            {/*<p onClick={() => dispatchContractId(changeContract({id: contracts.row.id, mcode: contracts.row.mcode, name: contracts.row.name, description: contracts.row.description }))}>*/}
                            {contracts.row.displayName} </p>
                        {/*</stack>*/}
                        {/*</Badge>*/}
                    </Tooltip>

                </div>
            );
        }

    },
    //
    {
        field: 'description',
        headerName: 'Description',
        description: '',
        sortable: false,
        editable: true,
        width: 400,
        hide: true
    },
    {
        field: 'id',
        headerName: 'ID',
        description: '',
        sortable: false,
        editable: true,
        width: 400,
        hide: true
    },
    {
        field: 'seriesId',
        headerName: 'Series ID',
        description: '',
        sortable: false,
        editable: true,
        width: 400,
        hide: true
    },

    {
        field: "contractDelete",
        headerName: '',
        width: 30,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filterable: false,
        hide: true,
        // renderCell: (cellValues) => {
        renderCell: (contracts) =>
            // {
            // return (
            <IconButton
                variant="contained"
                color="primary"
                // onClick={(event) => {
                //     handleClick(event, cellValues);
                // }}
            >
                {/*<DeleteOutlineIcon onClick={handleDeleteClickOpen}/>*/}
                <DeleteOutlineIcon fontSize={'small'}  onClick={() => removeContract(contracts.row.contractId, fetchContracts)}/>

                <Dialog
                    open={deleteOpen}
                    onClose={handleDeleteClose}
                    aria-labelledby="alert-delete-dialog-title"
                    aria-describedby="alert-delete-dialog-description"
                >
                    <DialogTitle id="alert-delete-dialog-title">
                        {"Delete Confirmation"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-delete-dialog-description">
                            {/*{`this is about ${getGridRowElement({GridRowId})}`}*/}
                            `You're going to delete contract ${()=>contracts.row.contractId}, you know.`
                            {/*{`You're going to delete contract ${getGridRowElement(contract,id)}, you know.`}*/}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDeleteCancel}>Cancel</Button>
                    </DialogActions>
                </Dialog>
            </IconButton>
    },
];